import React, { useState } from "react";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setLtrVsLtv } from "../../../redux/store/genericReportingSlice";
import FilterDropdown from "./FilterDropdown";

export default function LtrTabDropdowns() {

  return (
      <FilterDropdown />
  );
}
